<div class="insight-selection-summary">
    <div>
        <span class="insight-snsy-label">Period:</span>&nbsp;
        {{
            _finalPeriodTypeOpt != null
                ? (_finalPeriodTypeOpt | translate)
                : 'N/A'
        }}
    </div>
    <div
        class="cmps-cdk-border-l-width-1px cmps-cdk-border-l-solid cmps-cdk-border-l-color-grey-300 insight-snsy-separator"
    ></div>
    <div>
        <span class="insight-snsy-label">
            {{ _i18n._709_DATE_RANGE | translate }}: </span
        >&nbsp;
        {{ _finalDateRangeValue ?? 'N/A' }}
    </div>
    <ng-container *ngIf="_finalQuickSwitch?.length > 0">
        <div class="insight-snsy-separator"></div>
        <div>
            <span class="insight-snsy-label"
                >{{ _finalQuickSwitch | translate }}:</span
            >&nbsp;
            {{
                quickSwitchItem?.shortName != null
                    ? (quickSwitchItem.shortName | translate)
                    : 'N/A'
            }}
        </div>
    </ng-container>
</div>
